import React, { FC, FormEvent, useCallback, useState } from 'react'

import * as SC from './styled'
import { COVER_SEARCH_VARIANT } from './types'

export type CoverSearchProps = {
  placeholder: string
  onSearch: (search: string) => void
  initialValue?: string
  variant?: COVER_SEARCH_VARIANT
}

const CoverSearch: FC<CoverSearchProps> = (props) => {
  const {
    placeholder,
    onSearch,
    initialValue = '',
    variant = COVER_SEARCH_VARIANT.DEFAULT,
  } = props
  const [inputValue, setInputValue] = useState(initialValue)

  const onSubmit = useCallback(
    (e: FormEvent<HTMLFormElement>) => {
      e.preventDefault()
      onSearch(inputValue)
    },
    [inputValue, onSearch]
  )
  return (
    <SC.CoverSearch>
      <SC.CoverSearchContent>
        <SC.Form onSubmit={onSubmit}>
          <SC.Button type="submit">
            <SC.Svg icon="search" />
          </SC.Button>
          <SC.Input
            placeholder={placeholder}
            value={inputValue}
            onChange={({ target }) => setInputValue(target.value)}
            $variant={variant}
          />
        </SC.Form>
      </SC.CoverSearchContent>
    </SC.CoverSearch>
  )
}

export default CoverSearch
